import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component.js"

const PropTypes = require("prop-types")
const propTypesExact = require("prop-types-exact")

class EventListener extends ShapeComponent {
  static propTypes = propTypesExact({
    event: PropTypes.string.isRequired,
    onCalled: PropTypes.func.isRequired,
    target: PropTypes.object.isRequired
  })

  componentDidMount() {
    this.attachListener()
  }

  componentDidUpdate(prevProps) {
    // The listener is bound to a specific DOM node. When the target (or the
    // event name) changes - e.g. React replaced the node the ref points at -
    // the listener must move with it, otherwise events dispatched on the new
    // node never reach onCalled and silently do nothing.
    if (prevProps.target !== this.p.target || prevProps.event !== this.p.event) {
      prevProps.target.removeEventListener(prevProps.event, this.onCalled)
      this.attachListener()
    }
  }

  componentWillUnmount() {
    this.p.target.removeEventListener(this.p.event, this.onCalled)
  }

  attachListener() {
    this.p.target.addEventListener(this.p.event, this.onCalled)
  }

  onCalled = (...args) => this.p.onCalled(...args)

  render() {
    return null
  }
}

export default React.memo(shapeComponent(EventListener))
